module.exports = __webpack_public_path__ + "img/2_Dicks_Screen_L_1_L.2705e6f5.jpg";